/**
 * Идентификатор сборки SPA (вшивается при `npm run build` из VUE_APP_CRM_SPA_BUILD_ID).
 * Должен совпадать с CRM_SPA_BUILD_ID в backend после деплоя — см. docs/SPA_BUILD_ID.md.
 * Не путать с semver продукта (APP_VERSION / .version).
 *
 * Важно: не проверять `typeof process !== 'undefined'`. В браузере `process` нет;
 * Vue CLI DefinePlugin подставляет литерал вместо `process.env.VUE_APP_*` на этапе сборки.
 * Проверка `typeof process` отбрасывала вшитый id и всегда давала `'local'`.
 */
export const SPA_BUILD_ID: string = String(process.env.VUE_APP_CRM_SPA_BUILD_ID || '').trim() || 'local'
